import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { withIsSelectedHash } from '~/hocs/withIsSelectedHash';
import { withTreeNodeKeyDownHandler } from '~/hocs/withTreeNodeKeyDownHandler';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouting } from '~/routing/withRouting';
import { TreeNode } from '~/utils/TreeNode';

import FolderIcon from '../../Shared/Icons/FolderIcon';
import LoadingSpinner from '../../Shared/Icons/LoadingSpinner';
import { getFolderTree } from '../../UploadPage/UploadPage.data';
import EcFolderTreeItem from '../EcFolderTreeItem/EcFolderTreeItem';
import styles from './EcFolderPanel.styles';

const FolderTreeItem = withRouting(
  withTreeNodeKeyDownHandler(EcFolderTreeItem),
);

class EcFolderPanel extends Component {
  state = {
    folderTree: null,
  };

  componentDidMount() {
    this.setState({ loading: true });
    getFolderTree()
      .then((folderTree) => {
        this.setState({ folderTree: new TreeNode(folderTree), loading: false });
      })
      .catch(() => {
        this.setState({ loading: false, errorLoading: true });
      });
  }

  goToFolder = (folder) => this.props.navigate(`/documents/${folder.id}`);

  renderFolderTree(autoFocus = false) {
    const {
      classes,
      folderPathId,
      isRootFolder,
      getIsSelected,
      setIsSelected,
    } = this.props;
    const { folderTree, loading } = this.state;

    return (
      <div className={classes.folderTree}>
        {loading ? (
          <div className={classes.loadingContainer}>
            <LoadingSpinner size="medium" />
          </div>
        ) : folderTree ? (
          <FolderTreeItem
            autoFocus={autoFocus}
            firstToOpenId={folderPathId ? Number(folderPathId) : folderTree.id}
            folderIdsSelected={[]}
            folder={folderTree}
            forLinkOnly={true}
            getIsSelected={getIsSelected}
            isMultiSelect={false}
            isRootFolder={isRootFolder}
            onSelect={this.goToFolder}
            setIsSelected={setIsSelected}
          />
        ) : null}
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.folderPanelContainer}>
        <div className={classes.folderPanelHeader}>
          <span className={classes.folderPanelHeaderText}>
            <FolderIcon yellow />
            <FormattedMessage
              id="EcFolderPanel.goToFolder"
              defaultMessage="Go to a Folder"
              description="Header text for folder navigation panel"
            />
          </span>
        </div>
        <div className={classes.folderPanelContent}>
          <div />
          <div className={classes.modalBodyContent}>
            {this.renderFolderTree(true)}
          </div>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(
  withRouting(withIsSelectedHash(injectIntl(EcFolderPanel))),
);
